import { useState } from 'react';
// @mui
import { Stack, Box, Link, Typography } from '@mui/material';
// components
import FooterTile from 'src/components/subscription/FooterTile';
import HubspotContactForm from 'src/components/forms/HubspotContactForm';
import { contactFormConfig } from 'src/components/forms/hubspot-config';
// hooks
import useMerchant from 'src/hooks/useMerchant';
import { useTheme } from "@mui/material/styles";

// ----------------------------------------------------------------------

export default function NavbarDocs() {
  const [isOpenContactModal, setIsOpenContactModal] = useState(false);

  const { merchant } = useMerchant();
  const theme = useTheme();

  const footerMenu = [
    { name: 'FAQ', link: 'https://www.carbonclick.com/faqs' },
    { name: 'Contact us', onClick: () => setIsOpenContactModal(true) },
    { name: 'Terms & Conditions', link: 'https://www.carbonclick.com/terms/' },
    { name: 'Privacy Policy', link: 'https://www.carbonclick.com/privacy-policy/' },
    { name: 'www.carbonclick.com', link: 'https://www.carbonclick.com' },
  ]

  const linkStyle = {
    whiteSpace: 'nowrap',
    display: 'block',
    color: theme.palette.text.secondary,
  }

  return (
    <Stack
      spacing={2}
      sx={{ px: 2, pb: 2, width: 1, textAlign: 'center' }}
    >
      <FooterTile />

      <Box>
        {footerMenu?.map((item, idx) => (
          <Link target="_blank" key={idx} href={item?.link} onClick={item?.onClick} variant="body1"
            sx={{ ...linkStyle, fontWeight: 400 }}
          >
            {item?.name}
          </Link>
        ))}

        <Typography sx={{ ...linkStyle, mt: 2, overflow: 'hidden', textOverflow: 'ellipsis' }}>
          {merchant?.code}
        </Typography>
      </Box>

      {isOpenContactModal && (
        <HubspotContactForm
          isModalOpen={isOpenContactModal}
          setIsModalOpen={setIsOpenContactModal}
          region={contactFormConfig.region}
          portalId={contactFormConfig.portalId}
          formId={contactFormConfig.formId}
        />
      )}
    </Stack>
  );
}
